import {
    DELETE_PRODUCT_PROPERTY,
    DELETE_PRODUCT_PROPERTY_FAILURE,
    DELETE_PRODUCT_PROPERTY_SUCCESS,
} from 'store/actions/types';

// Delete Product Property
export const deleteProductProperty = (payload) => {
    return {
        type: DELETE_PRODUCT_PROPERTY,
        payload: payload,
    };
};

export const deleteProductPropertyFailure = (error) => {
    return {
        type: DELETE_PRODUCT_PROPERTY_FAILURE,
        error: error,
    };
};

export const deleteProductPropertySuccess = (payload) => {
    return {
        type: DELETE_PRODUCT_PROPERTY_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/productProperties/deleteProductProperties.js